import React from 'react';
import { ArticleSection } from './ArticleSection';
import { FaqItem } from './FaqItem';
import { faqs } from '../../data/faqs';
export function FaqSection() {
  return <ArticleSection id="faq" title="Frequently Asked Questions" data-id="element-86" data-mp="22bg919zgkxhx">
      <div className="border-t border-line" data-id="element-87" data-mp="229vg1osslmm6">
        {faqs.map((faq, index) => <FaqItem key={faq.question} id={`faq-${index + 1}`} question={faq.question} answer={faq.answer} data-id="element-88" data-mp="1y934uq0d17n9" data-mpi={index} />)}
      </div>
    </ArticleSection>;
}